import React from "react";
import { Button } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const getFieldLabel = (key) => {
  const labelMap = {
    deviceId: "Device IMEI",
    msisdn: "MSISDN",
    imsi: "IMSI",
    simType: "SIM Type",
    simState: "SIM State",
    profileType: "Profile Type",
    activationDate: "Activation Date",
    vendor: "Operator",
    whitelisting: "Whitelisting",
  };
  return labelMap[key] || key;
};

const DeviceDetailsCardContent = ({
  activeTab,
  selectedRow,
  superAdmin,
  planKeys,
  isEditingDeviceId,
  setIsEditingDeviceId,
  editDeviceIdValue,
  setEditDeviceIdValue,
  isSavingDeviceId,
  onSaveDeviceId,
  onShowSecondaryProfile,
  KYCDetails,
  loadingPlan,
  planDetails,
}) => {
  if (!selectedRow) return null;

  console.log(selectedRow, "selectedRow");

  switch (activeTab) {
    case "General data": {
      const primaryData = selectedRow._primaryData || selectedRow;
      const secondaryData = selectedRow._secondaryData;
      const tertiaryData = selectedRow._tertiaryData;

      const secondaryFieldsToShow = [
        "iccid",
        "msisdn",
        "imsi",
        "simType",
        "account",
        ...(superAdmin ? ["simState", "activationDate"] : []),
        "profileType",
        "vendor",
        "deviceId",
      ];

      const renderProfileCard = (
        title,
        data,
        showOpenAction = false,
        color = "#007bff",
      ) => {
        if (!data) return null;

        return (
          <div
            style={{
              background: "#f0f7ff",
              borderRadius: "16px",
              boxShadow: "0 6px 14px rgba(0,0,0,0.08)",
              padding: "24px 28px",
              border: `1px solid ${color}`,
              marginTop: "20px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: `2px solid ${color}`,
                paddingBottom: "8px",
                marginBottom: "20px",
              }}
            >
              <h3
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  color,
                  margin: 0,
                }}
              >
                {title}
              </h3>

              {showOpenAction && (
                <Button
                  style={{
                    minWidth: "auto",
                    padding: "4px",
                    color,
                  }}
                  onClick={() =>
                    onShowSecondaryProfile({
                      msisdn: data?.msisdn,
                    })
                  }
                >
                  <OpenInNewIcon />
                </Button>
              )}
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
                gap: "20px",
              }}
            >
              {secondaryFieldsToShow.map((key) => (
                <div key={key}>
                  <div
                    style={{
                      fontSize: "12px",
                      color,
                      marginBottom: "6px",
                      fontWeight: 600,
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    {getFieldLabel(key)}
                  </div>
                  <div
                    style={{
                      fontSize: "15px",
                      color: "#222",
                      fontWeight: 600,
                      wordWrap: "break-word",
                    }}
                  >
                    {data[key] || "-"}
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      };

      return (
        <div
          style={{
            padding: "24px 32px",
            maxHeight: "500px",
            overflowY: "auto",
            scrollbarWidth: "thin",
            msOverflowStyle: "none",
          }}
        >
          <style>
            {`
                    div::-webkit-scrollbar {
                      width: 6px;
                    }
                    div::-webkit-scrollbar-thumb {
                      background-color: rgba(0,0,0,0.2);
                      border-radius: 4px;
                    }
                    div::-webkit-scrollbar-thumb:hover {
                      background-color: rgba(0,0,0,0.35);
                    }
                  `}
          </style>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
              gap: "20px",
              marginBottom: secondaryData ? "30px" : "0px",
            }}
          >
            {Object.entries(primaryData)
              .filter(
                ([key]) =>
                  key !== "checked" &&
                  !planKeys.includes(key) &&
                  key !== "relationKey" &&
                  key !== "id" &&
                  key !== "activationDateTo" &&
                  key !== "activationDateFrom" &&
                  key !== "planId" &&
                  key !== "companyId" &&
                  key !== "euccid" &&
                  key !== "serialNo" &&
                  key !== "_primaryData" &&
                  key !== "_secondaryData" &&
                  !key.startsWith("profile1_") &&
                  !key.startsWith("profile2_"),
              )
              ?.map(([key, value]) => (
                <div key={key}>
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#888",
                      marginBottom: "4px",
                      fontWeight: 500,
                      textTransform: "uppercase",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    {getFieldLabel(key)}
                    {key === "deviceId" && (
                      <button
                        onClick={() => {
                          setIsEditingDeviceId(true);
                          setEditDeviceIdValue(value || "");
                        }}
                        style={{
                          background: "none",
                          border: "1px solid #007bff",
                          borderRadius: "4px",
                          color: "#007bff",
                          cursor: "pointer",
                          fontSize: "10px",
                          padding: "2px 6px",
                          textTransform: "uppercase",
                          fontWeight: 600,
                        }}
                        title="Edit Device Number"
                      >
                        Edit
                      </button>
                    )}
                  </div>
                  <div
                    style={{
                      fontSize: "15px",
                      color: "#333",
                      fontWeight: 600,
                      wordWrap: "break-word",
                    }}
                  >
                    {key === "deviceId" && isEditingDeviceId ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <input
                          type="text"
                          value={editDeviceIdValue}
                          onChange={(e) => setEditDeviceIdValue(e.target.value)}
                          style={{
                            padding: "6px 8px",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            fontSize: "14px",
                            width: "150px",
                          }}
                          placeholder="Enter Device Number"
                          autoFocus
                        />
                        <button
                          onClick={onSaveDeviceId}
                          disabled={isSavingDeviceId}
                          style={{
                            backgroundColor: "#28a745",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            padding: "6px 10px",
                            fontSize: "12px",
                            cursor: isSavingDeviceId
                              ? "not-allowed"
                              : "pointer",
                            opacity: isSavingDeviceId ? 0.6 : 1,
                          }}
                        >
                          {isSavingDeviceId ? "Saving..." : "Save"}
                        </button>
                        <button
                          onClick={() => {
                            setIsEditingDeviceId(false);
                            setEditDeviceIdValue("");
                          }}
                          style={{
                            backgroundColor: "#dc3545",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            padding: "6px 10px",
                            fontSize: "12px",
                            cursor: "pointer",
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      value || "-"
                    )}
                  </div>
                </div>
              ))}
          </div>
          {renderProfileCard(
            "Associated Profile Details",
            secondaryData,
            true,
            "#0056b3",
          )}
          {renderProfileCard(
            "Associated Tertiary Profile Details",
            tertiaryData,
            true,
            "#4e7257",
          )}
        </div>
      );
    }

    case "KYC Details": {
      if (!KYCDetails) {
        return (
          <div
            style={{
              textAlign: "center",
              padding: "40px",
              color: "#666",
              fontSize: "16px",
            }}
          >
            {loadingPlan ? "Loading KYC details..." : "No KYC details found"}
          </div>
        );
      }

      const kycDisplayData = [
        {
          key: "mobileNo",
          label: "Mobile No",
          value: KYCDetails?.mobileNo,
        },
        {
          key: "kycCompletionDate",
          label: "KYC Completion Date",
          value: KYCDetails?.kycCompletionDate
            ? new Date(KYCDetails.kycCompletionDate).toLocaleDateString()
            : "N/A",
        },
        {
          key: "status",
          label: "Status",
          value: KYCDetails?.status,
        },
        {
          key: "simStatus",
          label: "SIM Status",
          value: KYCDetails?.simStatus,
        },
        {
          key: "activationDate",
          label: "Activation Date",
          value: KYCDetails?.activationDate
            ? new Date(KYCDetails.activationDate).toLocaleDateString()
            : "N/A",
        },
        {
          key: "complianceDate",
          label: "Compliance Date",
          value: KYCDetails?.complianceDate
            ? new Date(KYCDetails.complianceDate).toLocaleDateString()
            : "N/A",
        },
        {
          key: "custodianName",
          label: "Custodian Name",
          value: KYCDetails?.custodianName,
        },
        {
          key: "custodianAddress",
          label: "Custodian Address",
          value: KYCDetails?.custodianAddress,
        },
      ];

      return (
        <div style={{ padding: "20px" }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
              gap: "24px",
              marginBottom: "30px",
            }}
          >
            {kycDisplayData?.map(({ key, label, value }) => (
              <div
                key={key}
                style={{
                  padding: "16px",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "8px",
                  border: "1px solid #e9ecef",
                }}
              >
                <div
                  style={{
                    fontSize: "12px",
                    color: "#6c757d",
                    marginBottom: "8px",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  {label}
                </div>
                <div
                  style={{
                    fontSize: "15px",
                    color: "#212529",
                    fontWeight: 600,
                    wordWrap: "break-word",
                  }}
                >
                  {value || "-"}
                </div>
              </div>
            ))}
          </div>

          {KYCDetails?.simNo && (
            <div
              style={{
                marginTop: "20px",
                padding: "20px",
                backgroundColor: "#e3f2fd",
                borderRadius: "12px",
                border: "1px solid #2196f3",
              }}
            >
              <h4
                style={{
                  fontSize: "16px",
                  fontWeight: 600,
                  marginBottom: "15px",
                  color: "#1976d2",
                }}
              >
                SIM Information
              </h4>
              <div style={{ fontSize: "14px", color: "#333" }}>
                <strong>SIM Number:</strong> {KYCDetails.simNo}
              </div>
              <div style={{ fontSize: "14px", color: "#333" }}>
                <strong>Failed Reason:</strong> {KYCDetails.errorMessage}
              </div>
              {KYCDetails.euiccId && (
                <div
                  style={{
                    fontSize: "14px",
                    color: "#333",
                    marginTop: "8px",
                  }}
                >
                  <strong>EUICCID:</strong> {KYCDetails.euiccId}
                </div>
              )}
            </div>
          )}
        </div>
      );
    }

    case "Plan Details": {
      if (!selectedRow.planId) {
        return (
          <div
            style={{
              textAlign: "center",
              padding: "40px",
              color: "#666",
              fontSize: "16px",
            }}
          >
            No plan assigned to this SIM
          </div>
        );
      }

      if (loadingPlan) {
        return (
          <div
            style={{
              textAlign: "center",
              padding: "40px",
              fontSize: "16px",
              color: "#666",
            }}
          >
            Loading plan details...
          </div>
        );
      }

      if (!planDetails) {
        return (
          <div
            style={{
              textAlign: "center",
              padding: "40px",
              color: "#d32f2f",
              fontSize: "16px",
            }}
          >
            Failed to load plan details
          </div>
        );
      }

      const planDisplayData = [
        { key: "planName", label: "Plan Name", value: planDetails.planName },
        {
          key: "dataAllowance",
          label: "Data Allowance",
          value: `${planDetails.dataAllowance} `,
        },
        {
          key: "smsAllowance",
          label: "SMS Allowance",
          value: `${planDetails.smsAllowance}`,
        },
        { key: "validity", label: "Validity", value: planDetails.validity },
        {
          key: "amount",
          label: "Amount",
          value: `${planDetails.currency} ${planDetails.amount}`,
        },
      ];

      return (
        <div style={{ padding: "20px" }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
              gap: "24px",
              marginBottom: "30px",
            }}
          >
            {planDisplayData?.map(({ key, label, value }) => (
              <div
                key={key}
                style={{
                  padding: "16px",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "8px",
                  border: "1px solid #e9ecef",
                }}
              >
                <div
                  style={{
                    fontSize: "12px",
                    color: "#6c757d",
                    marginBottom: "8px",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  {label}
                </div>
                <div
                  style={{
                    fontSize: "15px",
                    color: "#212529",
                    fontWeight: 600,
                    wordWrap: "break-word",
                  }}
                >
                  {value || "-"}
                </div>
              </div>
            ))}
          </div>

          {planDetails.oneTimeChargeList &&
            planDetails.oneTimeChargeList.length > 0 && (
              <div
                style={{
                  marginTop: "20px",
                  padding: "20px",
                  backgroundColor: "#fff3e0",
                  borderRadius: "12px",
                  border: "1px solid #ff9800",
                }}
              >
                <h4
                  style={{
                    fontSize: "16px",
                    fontWeight: 600,
                    marginBottom: "15px",
                    color: "#f57c00",
                  }}
                >
                  One Time Charges
                </h4>
                {planDetails.oneTimeChargeList?.map((charge, index) => (
                  <div
                    key={index}
                    style={{
                      padding: "8px 12px",
                      backgroundColor: "rgba(255, 152, 0, 0.1)",
                      borderRadius: "4px",
                      marginBottom: "8px",
                      fontSize: "14px",
                    }}
                  >
                    {charge}
                  </div>
                ))}
              </div>
            )}
        </div>
      );
    }

    default:
      return null;
  }
};

export default DeviceDetailsCardContent;
